// extracted by mini-css-extract-plugin
module.exports = {"mainCard":"MainWeatherCard_mainCard__m2KWU","MaincardEmpty":"MainWeatherCard_MaincardEmpty__3OUhM","switch":"MainWeatherCard_switch__VdTYc"};